{
  "Accessibility Menu": "অভিগম্যতা মেনু",
  "Reset settings": "নির্ধারণ পুনরায় সেট করুন",
  "Close": "বন্ধ করুন",
  "Content Adjustments": "কন্টেন্ট সংশোধন",
  "Adjust Font Size": "ফন্ট সাইজ সংশোধন",
  "Highlight Title": "শিরোনাম উজ্জ্বল করুন",
  "Highlight Links": "লিঙ্কগুলি উজ্জ্বল করুন",
  "Readable Font": "পঠনীয় ফন্ট",
  "Color Adjustments": "রঙ সংশোধন",
  "Dark Contrast": "অন্ধকারী প্রতিবিম্ব",
  "Light Contrast": "আলোকিত প্রতিবিম্ব",
  "High Contrast": "উচ্চ প্রতিবিম্ব",
  "High Saturation": "উচ্চ সত্রাজন",
  "Low Saturation": "নিম্ন সত্রাজন",
  "Monochrome": "একরঙ",
  "Contrast": "কনট্রাস্ট",
  "Invert Colors": "রং উল্টে দিন",
  "Tools": "সরঞ্জাম",
  "Reading Guide": "পড়ার গাইড",
  "Stop Animations": "অ্যানিমেশন বন্ধ করুন",
  "Big Cursor": "বড় কার্সর",
  "Increase Font Size": "ফন্ট সাইজ বাড়ান",
  "Decrease Font Size": "ফন্ট সাইজ কমান",
  "Letter Spacing": "অক্ষর বিরাটি",
  "Line Height": "লাইন উচ্চতা",
  "Font Weight": "ফন্ট ওজন",
  "Dyslexia Font": "ডাইসলেক্সিয়া ফন্ট",
  "Language": "ভাষা",
  "Open Accessibility Menu": "অভিগম্যতা মেনু খোলুন",
  "Widget Settings": "উইজেট সেটিংস",
  "Widget Position": "উইজেটের অবস্থান",
  "Top Left": "উপরের বাম",
  "Top Center": "উপরের মাঝামাঝি",
  "Top Right": "উপরের ডান",
  "Center Left": "মাঝের বাম",
  "Center Right": "মাঝের ডান",
  "Bottom Left": "নিচের বাম",
  "Bottom Center": "নিচের মাঝামাঝি",
  "Bottom Right": "নিচের ডান",
  "Screen Reader": "স্ক্রিন রিডার",
  "Voice Navigation": "ভয়েস নেভিগেশন",
  "Custom Color": "কাস্টম রং",
  "Change the site's colors": "সাইটের রং পরিবর্তন করুন",
  "Backgrounds": "পটভূমি",
  "Headings": "শিরোনাম",
  "Contents": "বিষয়বস্তু",
  "Reset colors": "রং পুনরায় নির্ধারণ করুন",
  "Image Desaturation": "ছবির রং কমানো",
  "Search languages": "ভাষা অনুসন্ধান করুন",
  "No languages found": "কোনো ভাষা পাওয়া যায়নি",
  "Accessibility Profiles": "অ্যাক্সেসিবিলিটি প্রোফাইল",
  "Motor Impaired": "মোটর প্রতিবন্ধকতা",
  "Big cursor, voice navigation, and no animations.": "বড় কার্সর, ভয়েস নেভিগেশন এবং কোন অ্যানিমেশন নেই।",
  "Blind": "দৃষ্টিহীন",
  "Screen reader helpers with higher contrast.": "উচ্চ কনট্রাস্ট সহ স্ক্রিন রিডার সহায়ক।",
  "Color Blind": "বর্ণান্ধ",
  "High contrast palette with desaturated media.": "উচ্চ কনট্রাস্ট প্যালেট এবং কম স্যাচুরেটেড মিডিয়া।",
  "Dyslexia": "ডিসলেক্সিয়া",
  "Friendly font, extra spacing, stronger weight.": "সহজ পাঠ্য ফন্ট, অতিরিক্ত ব্যবধান এবং আরও বোল্ড।",
  "Low vision": "দুর্বল দৃষ্টি",
  "Dark contrast and 130% magnification.": "গাঢ় কনট্রাস্ট এবং ১৩০% বড়করণ।",
  "Cognitive & Learning": "জ্ঞানীয় ও শেখা",
  "Highlights key sections and enables voice help.": "গুরুত্বপূর্ণ অংশগুলি হাইলাইট করে এবং ভয়েস সহায়তা সক্ষম করে।",
  "Seizure & Epileptic": "খিঁচুনি ও মৃগী",
  "Stops animations and desaturates imagery.": "অ্যানিমেশন থামায় এবং চিত্রের স্যাচুরেশন কমায়।",
  "ADHD": "এডিএইচডি",
  "Reading guide, highlighted links, calmer palette.": "পাঠ নির্দেশিকা, হাইলাইট করা লিংক এবং শান্ত রঙের প্যালেট।",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
